export * from './dashlastdoc.component';
